import type { MessageEventDTO } from '../types/assignments.types';

function formatDateTime(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`;
}

const EVENT_LABELS: Record<string, string> = {
  composer_presented: '打开编辑器',
  callback: '系统回调',
};

const EVENT_COLORS: Record<string, string> = {
  composer_presented: 'bg-blue-500',
  callback: 'bg-green-600',
};

export function MessageEventTimeline({ records }: { records?: MessageEventDTO[] | null }) {
  const sorted = [...(records ?? [])].sort((a, b) => {
    const timeDiff = new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
    return timeDiff !== 0 ? timeDiff : a.id - b.id;
  });

  return (
    <section className="space-y-3">
      <h3 className="text-base font-medium text-gray-900">事件时间线</h3>
      <div className="relative pl-6">
        <div className="absolute left-[9px] top-2 bottom-2 w-px bg-gray-200" />
        {sorted.length === 0 ? (
          <p className="text-sm text-gray-400">暂无事件记录</p>
        ) : (
          sorted.map((event, index) => (
            <div key={`${event.session_id}-${event.event_id}-${index}`} className="relative pb-4 last:pb-0">
              <div className={`absolute -left-6 top-1 h-[10px] w-[10px] rounded-full ${EVENT_COLORS[event.event_type] ?? 'bg-gray-400'} ring-2 ring-white`} />
              <div className="space-y-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-sm font-medium text-gray-900">{EVENT_LABELS[event.event_type] ?? event.event_type}</span>
                  <span className="text-xs text-gray-500">{event.native_result}</span>
                  <span className="text-xs text-gray-400">{formatDateTime(event.created_at)}</span>
                </div>
                <p className="text-xs text-gray-600 break-all">
                  {event.state_before} → {event.state_after}
                </p>
                <p className="text-xs text-gray-500 break-all">结果码: {event.result_code || '-'}</p>
                <p className="text-xs text-gray-500 break-all">事件 ID: {event.event_id}</p>
                {event.challenge_id && (
                  <p className="text-xs text-gray-500 break-all">Challenge: {event.challenge_id}</p>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </section>
  );
}
